<div class="app-shell">
  <header>
    <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="timer" [fullScreen]="true">
    </ngx-spinner>

    <app-menu-nav *ngIf="showNav$ | async" [buildDate]="buildDate"></app-menu-nav>
    <app-menu-home-autogestion *ngIf="showNavAutogestion$ | async"></app-menu-home-autogestion>
  </header>

  <main>
    <router-outlet></router-outlet>
  </main>

  <footer *ngIf="showFooter" class="app-footer" aria-label="Pie de página">
    <img class="footer-logo" src="assets/images/SBOT/SBOT_LOGO.png" alt="SniperBot">
    <a class="footer-brand" href="https://www.sniperbot.com.ar" target="_blank" rel="noopener noreferrer">
      SniperBot<sup>®</sup>
    </a>
    <span *ngIf="isFooterUserVisible && footerUserName" class="footer-user-info"
      [title]="'Usuario: ' + footerUserName + (footerLoginDate ? ' (Inicio sesión: ' + (footerLoginDate | date:'dd/MM/yyyy HH:mm') + ')' : '')">
      Usuario: {{ footerUserName }}<ng-container *ngIf="footerLoginDate">
        (Inicio sesión: {{ footerLoginDate | date:'dd/MM/yyyy HH:mm' }})
      </ng-container>
    </span>
  </footer>
</div>
